@if (isSample && taskDocuments && taskDocuments.length > 0) {
    <div class="d-flex flex-column">
        @for (doc of taskDocuments; track doc) {
            <div class="document-container d-flex flex-row gap-2">
                <i class="fas fa-regular fa-link-horizontal regular-text-small ocean-blue"></i>
                <div
                    (click)="onEditDeleteTaskDocument(doc)"
                    class="regular-text-small document-name text-ellipsis"
                    title=" {{ doc.Name }} "
                >
                    {{ doc.Name }}
                </div>
                <div class="document-actions d-flex flex-row align-items-center gap-2">
                    @if (doc.Description) {
                        <div>
                            <eff-icon class="action-icon" icon="comment_outlined"></eff-icon>
                        </div>
                    }
                    @if (!doc.IsNew && doc.Name && doc.Name.endsWith(".pdf")) {
                        <eff-icon
                            (click)="openDocumentViewer(doc)"
                            icon="find_in_page_outlined"
                            class="action-icon"
                        ></eff-icon>
                    }
                    <eff-icon
                        class="action-icon"
                        icon="cloud_download_outlined"
                        (click)="downloadDocument(doc)"
                    ></eff-icon>
                </div>
            </div>
        }
    </div>
}

@if (filteredDocuments().length > 0) {
    <div class="d-flex flex-column">
        @for (doc of filteredDocuments(); track doc) {
            <div class="document-container d-flex flex-row gap-2">
                <div
                    (click)="onEditDeleteDocument(doc)"
                    class="regular-text-small document-name text-ellipsis"
                    title=" {{ doc.Name }} "
                >
                    {{ doc.Name }}
                </div>
                <div class="document-actions d-flex flex-row align-items-center gap-2">
                    @if (doc.Description) {
                        <div>
                            <eff-icon class="action-icon" icon="comment_outlined"></eff-icon>
                        </div>
                    }
                    @if (!doc.IsNew && doc.Name && doc.Name.endsWith(".pdf")) {
                        <eff-icon
                            (click)="openDocumentViewer(doc)"
                            icon="find_in_page_outlined"
                            class="action-icon"
                        ></eff-icon>
                    }
                    <eff-icon
                        class="action-icon"
                        icon="cloud_download_outlined"
                        (click)="downloadDocument(doc)"
                    ></eff-icon>
                </div>
            </div>
        }
    </div>
}
@if (canAdd) {
    <eff-drop-files-area
        [allowedFileExtensions]="allowedFileExtensions"
        [allowDrop]="canAdd"
        [attr.data-uiid]="'documents-list-drop-area'"
        (onDroppedFiles)="onFilesDropped($event)"
    >
    </eff-drop-files-area>
}
